import styled from "styled-components";

export const DetailPageContainer = styled.div`
  max-width: 1100px;
  margin: 2rem auto;
  padding: 2rem;
`;

export const MainImgWrapper = styled.div`
  min-width: 200px;
  width: 100%;
  height: 100%;
  position: relative;
  padding-top: 75%;
  display: flex;
  border: none;
`;

export const DescriptionContentContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const DescriptionContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 12px;
`;

export const DescriptionFollowers = styled.div`
  display: flex;
  flex-direction: row;
  -webkit-box-align: center;
  align-items: center;
`;
